import Loading from "components/Loading";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import SettingsTable from "./SettingsTable";
import { getSetting } from "services/setting.routes";
import { toast } from "react-toastify";

export default function Settings() {
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState([]);

    useEffect(() => {
        setLoading(true);
        getSetting((isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                setSettings(data);
            }
        })
    }, []);
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <SettingsTable data={settings} setSettings={setSettings} />
        </DashboardLayout>
    )
}